const locationSearchForm = document.querySelector('#find-branch-form');

if (locationSearchForm) {
	function initialize() {

		//Branch search
		/*var locSearch = document.querySelector(".js-branch-modal-search-form");*/
		document.addEventListener("submit", function (e) {
			if (e.target.matches("form#find-branch-form")) {
				e.preventDefault();
				var inp = document.querySelector("#addressInput");
				//loadBranchAddress(encodeLocationHTML(inp.value));
				const map = document.querySelector("#map");
				loadBranchAddress(inp.value)
				vSlideDown(map);
			}
		}, false);
	}
	initialize();
	let map;

	async function initMap(position = "") {
		// The location of Uluru
		// Request needed libraries.
		const { Map } = await google.maps.importLibrary("maps");
		const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

		// The map, centered at Uluru
		map = new Map(document.getElementById("map"), {
			zoom: 15,
			center: position,
			mapId: "DEMO_MAP_ID",
		});

		// The marker, positioned at Uluru
		const locations = document.querySelectorAll(".js-location");
		locations.forEach((location) => {
			loadBranchAddress(location.dataset.address, true, AdvancedMarkerElement, location.querySelector('.location-name').innerText, map)
		})
		
	}

	initMap();

	function loadBranchAddress(address, createMarker = false, AdvancedMarkerElement = "", title = "", map = "") {
		
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode(
			{
				address: address,
			},
			async function (results, status) {
				console.log("geocoder created");
				if (status == google.maps.GeocoderStatus.OK) {
					coords = results[0].geometry.location;
					//console.log(coords);

					//searchBox.style.display = "none";
					//document.querySelector(".searchedAddress #searchedAddress").innerText = input.value;

					/*          map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));*/
					if (createMarker) {
						const marker = new AdvancedMarkerElement({
							map,
							position: { lat: coords.lat(), lng: coords.lng() },
							title: title
						});
					} else {
						await initMap(position = { lat: coords.lat(), lng: coords.lng() })
					}
					
					return;
				} else {
					console.log("Address Not Found");
					//input.classList.add("not-found");
					//input.value = "Address Not Found";
					return false;
				}
			}
		);
	}
}
        